/**
 * Mapping from technical object type names to user-friendly display names
 */

// Account-level audit object types
export const accountObjectTypeMapping: Record<string, string> = {
  APICredentials: 'API Credentials',
  Account: 'Account',
  BillingPlan: 'Billing Plan',
  BillingSubscription: 'Billing Subscription',
  ExternalAPIKey: 'External API Key',
  IP: 'IP Address',
  Plan: 'Plan',
  Receipt: 'Receipt',
  Role: 'Role',
  SCIMConfiguration: 'SCIM Configuration',
  SCIMToken: 'SCIM Token',
  SSOConfiguration: 'SSO Configuration',
  Session: 'Session',
  Subscription: 'Subscription',
  TaxRate: 'Tax Rate',
  User: 'User',
  WhitelistedIP: 'Whitelisted IP',
  Workspace: 'Workspace',
  WorkspacePermissions: 'Workspace Permissions',
};

// Workspace-level audit object types
export const workspaceObjectTypeMapping: Record<string, string> = {
  Asset: 'Asset',
  Audience: 'Audience',
  AudienceCredentials: 'Audience Credentials',
  Campaign: 'Campaign',
  CampaignAction: 'Campaign Action',
  Collection: 'Collection',
  Condition: 'Condition',
  Credentials: 'Credentials',
  CustomForm: 'Custom Form',
  CustomSMTP: 'Custom SMTP',
  Domain: 'Domain',
  Export: 'Export',
  Import: 'Import',
  InAppBroadcast: 'In-App Broadcast',
  Integration: 'Integration',
  JourneyExit: 'Journey Exit',
  Layout: 'Layout',
  Newsletter: 'Newsletter',
  ObjectDeletion: 'Object Deletion',
  ObjectType: 'Object Type',
  ProfileDeletion: 'Profile Deletion',
  ProfileMerge: 'Profile Merge',
  ProfileShortcut: 'Profile Shortcut',
  SQLImport: 'SQL Import',
  SQLImportDatabaseDefinition: 'SQL Import Database Definition',
  SavedRow: 'Saved Row',
  Segment: 'Segment',
  SenderIdentity: 'Sender Identity',
  Snippet: 'Snippet',
  SubscriptionCenterSettings: 'Subscription Center Settings',
  SubscriptionTopic: 'Subscription Topic',
  Tag: 'Tag',
  Template: 'Template',
  TransactionalMessage: 'Transactional Message',
  WebhookConfiguration: 'Webhook Configuration',
};

/**
 * Get user-friendly name for an object type based on context
 */
export function getObjectTypeDisplayName(objectType: string, context: 'account' | 'workspace'): string {
  const mapping = context === 'account' ? accountObjectTypeMapping : workspaceObjectTypeMapping;
  return mapping[objectType] !== undefined && mapping[objectType] !== '' ? mapping[objectType] : objectType;
}

/**
 * Get all available object types for a context as dropdown options
 */
export function getObjectTypeOptions(context: 'account' | 'workspace'): Array<{ value: string; label: string }> {
  const mapping = context === 'account' ? accountObjectTypeMapping : workspaceObjectTypeMapping;

  return [
    { value: '', label: 'All Object Types' },
    ...Object.entries(mapping)
      .sort(([, a], [, b]) => a.localeCompare(b))
      .map(([key, value]) => ({ value: key, label: value })),
  ];
}
